import { Link } from "react-router-dom";
import styles from "./PageEdit.module.css"

export default function Navbar() {
  return (
    <nav className={styles.nav}>
      <ul>
        <li><Link to="/"><h3>Dashboard</h3></Link></li>
        <li><Link to="/forside">Forside</Link></li>
        <li><Link to="/kontakt">Kontakt</Link></li>
        <li><Link to="/bloggen">Blog</Link></li>
        <h3>Fællesskaber</h3>
        <ul>
          <li><Link to="/boern"> Børn</Link></li>
          <li><Link to="/junior-teen"> Junior Teen</Link></li>
          <li><Link to="/unge"> Unge</Link></li>
          <li><Link to="/kristendomskursus"> Kristendomskursus</Link></li>
          <li><Link to="/andre"> Andre</Link></li>
          <li><Link to="/alle"> Alle</Link></li>
        </ul>
        <h3>Gudstjeneste</h3>
        <ul>
          <li><Link to="/gudstjeneste"> Gudstjeneste</Link></li>
          <li><Link to="/kirkelige-handlinger"> Kirkelige Handlinger</Link></li>
          <li><Link to="/praedikener"> Prædikener</Link></li>
        </ul>
        <h3>Om Os</h3>
        <ul>
          <li><Link to="/hvem-vi-er"> Hvem vi er</Link></li>
          <li><Link to="/ledelse-og-ansatte"> Ledelse og Ansatte</Link></li>
          <li><Link to="/det-vi-tror-paa"> Det Vi Tror På</Link></li>
        </ul>
      </ul>
    </nav>
  );
}